module.exports = __webpack_public_path__ + "static/media/de_inferno.832bd1cd.jpg";